import { render, staticRenderFns } from "./content-loader.vue?vue&type=template&id=4623e8a4"
import script from "./content-loader.vue?vue&type=script&lang=js"
export * from "./content-loader.vue?vue&type=script&lang=js"
import style0 from "./content-loader.vue?vue&type=style&index=0&id=4623e8a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports